/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectSite } from 'services/site/selectors'
import {
  selectConsentRegion,
  selectConfirmCountry,
  selectConsentMatrix,
  selectConsentMatrixLoading,
  selectConsentContent,
} from 'services/consents/selectors'
import { SectionContent, PrivacyWrapper, PrivacyLinks, MobileFooter, WebFooter } from '../util'
import CountrySelect from './CountrySelect'
import * as consentActions from 'services/consents/actions'

const mapStateToProps = (state) => ({
  site: selectSite(state),
  consentRegion: selectConsentRegion(state),
  consentMatrix: selectConsentMatrix(state),
  matrixLoading: selectConsentMatrixLoading(state),
  confirmCountry: selectConfirmCountry(state),
  consent: selectConsentContent(state),
})

const mapDispatchToActions = {
  ...consentActions,
}

function PrivacyCenterContent (props) {
  const {
    site,
    consentRegion,
    initiateCountryConfirmation,
    matrixLoading,
    cancelCountryConfirmation,
    fetchConsentMatrix,
    confirmCountry,
    updateConsents,
    consentMatrix,
    consent,
    isMobile,
  } = props
  const appName = site.name || 'MapMyRun'

  return (
    <PrivacyWrapper>
      <SectionContent>
        <b>
          <FormattedMessage
            id='privacy_center.manage.title'
            defaultMessage="Manage your privacy and data protection usage with Under Armour, Inc. and { appName }."
            values={ { appName } }
          />
        </b>
      </SectionContent>

      { consentRegion ?
        <CountrySelect
          consent={consent}
          consentRegion={consentRegion}
          initiateCountryConfirmation={initiateCountryConfirmation}
          cancelCountryConfirmation={cancelCountryConfirmation}
          confirmCountry={confirmCountry}
          consentMatrix={consentMatrix}
          matrixLoading={matrixLoading}
          updateConsents={updateConsents}
          fetchConsentMatrix={fetchConsentMatrix}
        />
        : null }

      <PrivacyLinks
        editConsents={consentRegion !== 'US'}
        exportData={true}
        accountDelete={true}
        contactSupport={true}
        logout={true}
        isMobile={isMobile}
        screenName='privacy_center'
      />

      { isMobile ? <MobileFooter /> : <WebFooter /> }
    </PrivacyWrapper>
  )
}

PrivacyCenterContent.propTypes = {
  site: PropTypes.object,
  location: PropTypes.object,
  consentMatrix: PropTypes.object,
  confirmCountry: PropTypes.string,
  updateConsents: PropTypes.func,
  initiateCountryConfirmation: PropTypes.func,
  cancelCountryConfirmation: PropTypes.func,
  fetchConsentMatrix: PropTypes.func,
  consentRegion: PropTypes.string,
  isMobile: PropTypes.bool,
  matrixLoading: PropTypes.bool,
  consent: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToActions)(PrivacyCenterContent)



// WEBPACK FOOTER //
// ./src/components/privacy_center/manage/ManageContent.jsx